"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedAlgorithms = void 0;
var hmac_sha256_1 = __importDefault(require("crypto-js/hmac-sha256"));
var hmac_sha384_1 = __importDefault(require("crypto-js/hmac-sha384"));
var hmac_sha512_1 = __importDefault(require("crypto-js/hmac-sha512"));
var mapping = {
    HS256: hmac_sha256_1.default,
    HS384: hmac_sha384_1.default,
    HS512: hmac_sha512_1.default,
};
exports.supportedAlgorithms = Object.keys(mapping);
exports.default = mapping;
